import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { EventType, EventMessage, AuthenticationResult } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import './index.css';
import App from './App';
import { msalInstance } from './config/authConfig';
import { markSharedLogout, writeSharedAccount } from './utils/authSync';

// Initialize MSAL and handle redirect promise
msalInstance.initialize().then(() => {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      const account = payload.account;
      msalInstance.setActiveAccount(account);
      if (account) {
        // Let the sibling apps detect a logout or an account switch here.
        writeSharedAccount(account.homeAccountId);
      }
    }

    // Handled here rather than at each call site so it covers every logout
    // path in the app (utils/auth.ts's logOut, and useAuth's logout and
    // logoutRedirect). LOGOUT_START, not LOGOUT_SUCCESS: logoutRedirect
    // navigates the page away, so a success event may never be delivered.
    if (event.eventType === EventType.LOGOUT_START) {
      markSharedLogout();
    }
  });

  // Handle redirect promise
  msalInstance.handleRedirectPromise().catch((error) => {
    console.error('Redirect promise error:', error);
  });

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
});